import { Button, Form, Input, Modal } from "antd";
import { useMutation, useQueryClient } from "react-query";
import { useForm } from "antd/es/form/Form";
import { processGiftCard } from "../../../api/trade";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const DeclineGiftCardTrade = ({ open = false, setOpen, id }) => {
  const queryClient = useQueryClient();
  const [form] = useForm();

  const mutation = useMutation(processGiftCard, {
    onSuccess: () => {
      queryClient.invalidateQueries("gift-card-request");
      queryClient.invalidateQueries("giftcard-history");
      setOpen(false);
      showSuccessToast("Action successful");
    },
    onError: (e) => showErrorToast(e.message),
  });

  const onFinish = (values) => {
    mutation.mutate({
      ...values,
      status: 'declined',
      id,
    });
  };

  return (
    <Modal
      title="Decline Trade"
      open={open}
      footer={null}
      onCancel={() => setOpen(false)}
    >
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Form.Item name="reason" label="Why are you declining?">
          <Input />
        </Form.Item>

        <Button
          className="bg-dark text-white rounded-[5px] font-bold text-[15px]"
          htmlType="submit"
          loading={mutation.isLoading}
        >
          Continue
        </Button>
      </Form>
    </Modal>
  );
};

export default DeclineGiftCardTrade;
